
/**
 * detect IE
 * returns version of IE or false, if browser is not Internet Explorer
 * https://gist.github.com/ccurtin/6fb05b7739e6e538e783
 */

(function detectIE() {
  var ua = window.navigator.userAgent;

  var msie = ua.indexOf('MSIE ');
  if (msie > 0) {
      // IE 10 or older => return version number
      var ieV = parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
      document.querySelector('body').className += ' IE';
  }

  var trident = ua.indexOf('Trident/');
  if (trident > 0) {
      // IE 11 => return version number
      var rv = ua.indexOf('rv:');
      var ieV = parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
      document.querySelector('body').className += ' browser-ie11';
  }

  var edge = ua.indexOf('Edge/');
  if (edge > 0) {
     // IE 12 (aka Edge) => return version number
     var ieV = parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
      document.querySelector('body').className += ' IE';
  }

  // other browser
  return false;
})();
